import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitBranches } from '@/services/git/api';
import type { GitBranch } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitBranches(repoFullName: string | null | undefined): UseQueryResult<GitBranch[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitBranches', orgId, repoFullName],
    queryFn: () => fetchGitBranches(orgId!, repoFullName!),
    enabled: !!token && !!orgId && !!repoFullName,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    meta: { silent: true },
  });
}
